import React, { Component } from "react";
import PropTypes from "prop-types";

import BookingButton from "./BookingButton";

import SportSolutionApiWrapper from "../utils/SportSolutionApiWrapper";

import moment from "moment/moment.js";

import { Table } from "react-bootstrap";

class Bookings extends Component {
  constructor() {
    super();
    this.renderBooking = this.renderBooking.bind(this);
    this.renderBookings = this.renderBookings.bind(this);
    this.renderHead = this.renderHead.bind(this);
    this.state = {
      bookings: [],
      i18nKeeper: document.querySelector("#i18n").dataset
    };
  }

  componentWillMount() {
    this.setState({ bookings: this.props.bookings });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ bookings: nextProps.bookings });
  }

  renderBooking(booking) {
    let start = moment(booking.start_date_time);
    let status = this.state.i18nKeeper.booked;
    let standby = booking.number_on_booking_list - booking.ss_event.capacity;
    if (standby > 0) {
      status = `${this.state.i18nKeeper.standby} (${standby})`;
    }
    return (
      <tr key={booking.id}>
        <td>{booking.ss_event.name}</td>
        <td>{booking.ss_event.gym.name}</td>
        <td>
          {start.format("dddd")}&nbsp;
          {start.format("DD")}&nbsp;
          {start.format("MMM")} — {start.format("HH:mm")}
        </td>
        <td>{status}</td>
        <td>
          <BookingButton
            booking={booking}
            getBookings={this.props.getBookings}
            user={this.props.user}
            popup={this.props.popup}
            getCenterNameById={this.props.getCenterNameById}
            className="pull-right"
          />
        </td>
      </tr>
    );
  }

  renderBookings() {
    return Object.keys(this.state.bookings).map(idx =>
      this.renderBooking(this.state.bookings[idx])
    );
  }

  renderHead() {
    if (Object.keys(this.state.bookings).length > 0) {
      return (
        <thead>
          <tr>
            <th>{this.state.i18nKeeper.class}</th>
            <th>{this.state.i18nKeeper.gym}</th>
            <th>{this.state.i18nKeeper.classStart}</th>
            <th>{this.state.i18nKeeper.status}</th>
            <th />
          </tr>
        </thead>
      );
    } else {
      return <thead />;
    }
  }

  render() {
    return (
      <div className="bookings-wrapper">
        <table>
          {this.renderHead()}
          <tbody>{this.renderBookings()}</tbody>
        </table>
      </div>
    );
  }
}

export default Bookings;



// WEBPACK FOOTER //
// ./app/javascript/components/Bookings.jsx